import { useEffect } from 'react'

const protectedMediaSelector = 'img, video, .protected-media'

function targetsProtectedMedia(target: EventTarget | null) {
  return target instanceof Element && Boolean(target.closest(protectedMediaSelector))
}

export function useMediaDownloadDeterrence() {
  useEffect(() => {
    // Casual deterrence only: screenshots, DevTools and network extraction remain possible.
    const preventProtectedMediaAction = (event: Event) => {
      if (targetsProtectedMedia(event.target)) event.preventDefault()
    }

    document.addEventListener('contextmenu', preventProtectedMediaAction, true)
    document.addEventListener('dragstart', preventProtectedMediaAction, true)

    return () => {
      document.removeEventListener(
        'contextmenu',
        preventProtectedMediaAction,
        true,
      )
      document.removeEventListener('dragstart', preventProtectedMediaAction, true)
    }
  }, [])
}
